<template>
  <div class="transform transition-transform duration-100 bg-gray-800 text-white">
    <div class="flex items-center cursor-pointer hover:bg-gray-900" @click="config.liveStreams = !config.liveStreams">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.liveStreams ? 'fa-check-square' : 'fa-square'" /> List of streams</div>
      <div class="p-3 hover:text-yellow-200" :class="config.liveStreams ? 'text-gray-400' : 'text-gray-700 pointer-events-none'" title="Update interval" @click.stop="toggleConfigKey('liveUpdates', [0, 10000, 60000, 300000, 600000, 1800000, 3600000])">
        <i class="fa fa-sync-alt" />
        {{ config.liveUpdates ? prettyDuration(config.liveUpdates / 1000) : 'OFF' }}
      </div>
    </div>
    <div class="flex items-center cursor-pointer hover:bg-gray-900" :class="{ 'text-gray-700 pointer-events-none': !config.liveStreams }" title="Update interval" @click="config.livePreviews = !config.livePreviews">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.livePreviews ? 'fa-check-square' : 'fa-square'" /> Stream previews</div>
      <div class="p-3 hover:text-yellow-200" :class="config.livePreviews && config.liveStreams ? 'text-gray-400' : 'text-gray-700 pointer-events-none'" @click.stop="toggleConfigKey('previewUpdates', [0, 60000, 300000, 600000, 1800000, 3600000])">
        <i class="fa fa-sync-alt" />
        {{ config.previewUpdates ? prettyDuration(config.previewUpdates / 1000) : 'OFF' }}
      </div>
    </div>
    <div class="flex items-center cursor-pointer hover:bg-gray-900" :class="{ 'text-gray-700 pointer-events-none': !config.livePreviews || !config.liveStreams }" @click="config.liveTimers = !config.liveTimers">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.liveTimers ? 'fa-check-square' : 'fa-square'" /> Stream timers</div>
    </div>
    <div class="flex items-center cursor-pointer hover:bg-gray-900" @click="config.channels = !config.channels">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.channels ? 'fa-check-square' : 'fa-square'" /> List of avatars</div>
    </div>
    <div class="flex items-center cursor-pointer hover:bg-gray-900" @click="config.icons = !config.icons">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.icons ? 'fa-check-square' : 'fa-square'" /> Icons</div>
      <div class="p-3 hover:text-yellow-200" :class="config.icons ? 'text-gray-400' : 'text-gray-700 pointer-events-none'" title="Type of icons" @click.stop="toggleConfigKey('iconType', ['Avatar', 'Logo'])">
        <i class="fa fa-image" />
        {{ config.iconType }}
      </div>
      <div class="p-3 hover:text-yellow-200" :class="config.icons ? 'text-gray-400' : 'text-gray-700 pointer-events-none'" title="Size of icons" @click.stop="toggleConfigKey('iconSize', [50, 100, 150])">
        <i class="fa fa-expand" />
        {{ config.iconSize }}px
      </div>
    </div>
    <div class="flex space-x-1 cursor-pointer hover:bg-gray-900" @click="config.names = !config.names">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.names ? 'fa-check-square' : 'fa-square'" /> Names</div>
    </div>
    <div class="flex items-center cursor-pointer hover:bg-gray-900" @click="config.followers = !config.followers">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.followers ? 'fa-check-square' : 'fa-square'" /> Followers</div>
      <div class="p-3 hover:text-yellow-200" :class="config.followers ? 'text-gray-400' : 'text-gray-700 pointer-events-none'" title="Show changes" @click.stop="config.followersDiff = !config.followersDiff">
        <i class="fa fa-user-plus" />
        {{ config.followersDiff ? 'ON' : 'OFF' }}
      </div>
    </div>
    <div class="flex space-x-1 cursor-pointer hover:bg-gray-900" @click="config.language = !config.language">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.language ? 'fa-check-square' : 'fa-square'" /> Language icons</div>
    </div>
    <div class="flex space-x-1 cursor-pointer hover:bg-gray-900" @click="config.partners = !config.partners">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.partners ? 'fa-check-square' : 'fa-square'" /> Twitch Partner icons</div>
    </div>
    <div class="flex space-x-1 cursor-pointer hover:bg-gray-900" @click="config.possession = !config.possession">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.possession ? 'fa-check-square' : 'fa-square'" /> Possession checkboxes</div>
    </div>
    <div class="flex space-x-1 cursor-pointer hover:bg-gray-900" @click="config.favorites = !config.favorites">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.favorites ? 'fa-check-square' : 'fa-square'" /> Favorites checkboxes</div>
    </div>
    <div class="flex space-x-1 cursor-pointer hover:bg-gray-900" @click="config.lastStream = !config.lastStream">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.lastStream ? 'fa-check-square' : 'fa-square'" /> Last stream dates</div>
    </div>
    <div class="flex space-x-1 cursor-pointer hover:bg-gray-900" @click="config.leaderboard = !config.leaderboard">
      <div class="p-3 flex-1 hover:bg-gray-900"><i class="fa" :class="config.leaderboard ? 'fa-check-square' : 'fa-square'" /> Leaderboard</div>
    </div>
    <div class="flex space-x-1 cursor-pointer text-gray-300 hover:text-white hover:bg-green-900" @click="exportAvatars()">
      <div class="p-3 flex-1 text-sm leading-3">Export my avatars<br /><span class="text-gray-400 text-xs font-normal">The list will be copied to your clipboard</span></div>
    </div>
    <div class="flex space-x-1 cursor-pointer text-gray-300 hover:text-white hover:bg-blue-900" @click="importAvatars()" v-if="isImportAvailable">
      <div class="p-3 flex-1 text-sm leading-3">Import my avatars from<br /><a class="text-blue-300 text-xs font-normal" href="https://quakelife.ru/diabotical/avatars/" target="_blank" @click.stop>https://quakelife.ru/diabotical/avatars/</a></div>
    </div>
  </div>
</template>

<script>
  import { config } from '@/store'
  import { isImportAvailable, toggleConfigKey, importAvatars, exportAvatars } from '@/store'
  import { prettyDuration } from '@/utils'

  export default {
    name: 'Settings',
    setup() {
      return {
        config,
        isImportAvailable,
        prettyDuration,
        toggleConfigKey,
        importAvatars,
        exportAvatars,
      }
    },
  }
</script>
